import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteUploadTarget } from "../../../data/usecases/target/remote-upload-target";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { UploadTarget } from "../../../domain/useages/target/upload-target";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface UploadTargetInterface {
  uploadTarget: Function;
  uploadTargetState: FetchState;
}

const initialState = {
  uploadTargetState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useUploadTargetSlice: StateCreator<UploadTargetInterface> = (
  set,
  get
) => ({
  ...initialState,
  uploadTarget: async (params: UploadTarget.Params) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    set({ uploadTargetState: FetchState.LOADING });

    const remoteUploadTarget = new RemoteUploadTarget(
      `${BASE_URL}${Endpoints.FETCH_TARGET}`,
      axiosHttpClient
    );

    let result = await remoteUploadTarget.upload(params);
    if (result) {
      Swal.fire({
        icon: "success",
        timer: 3000,
        text: result.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
      set({ uploadTargetState: FetchState.SUCCESS });
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: result.errors.message ?? result.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
      set({ uploadTargetState: FetchState.SUCCESS });
    }
  },
});
